import React from "react";
import { useTranslation } from "react-i18next";
import { TypeSpecificFieldsProps } from "./types";
import { useFieldChoices } from "./useFieldChoices";

const LifeFields: React.FC<TypeSpecificFieldsProps> = ({ data, onChange }) => {
  const { t } = useTranslation(['insurance', 'common']);
  const set = (key: string, value: any) => onChange({ ...data, [key]: value });

  const lifePolicyTypes = useFieldChoices("life", "life_policy_type");

  return (
    <div className="irf-grid">
      <div className="irf-field">
        <label>{t('insurance:life.lifePolicyType')}</label>
        <select
          value={data.life_policy_type || ""}
          onChange={(e) => set("life_policy_type", e.target.value)}
        >
          <option value="">{t('insurance:life.selectType')}</option>
          {lifePolicyTypes.map((tp) => (
            <option key={tp.value} value={tp.value}>{tp.label}</option>
          ))}
        </select>
      </div>
      <div className="irf-field">
        <label>{t('insurance:life.deathBenefit')}</label>
        <input
          type="number"
          value={data.death_benefit ?? ""}
          onChange={(e) => set("death_benefit", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:life.deathBenefitPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:life.maturityDate')}</label>
        <input
          type="date"
          value={data.maturity_date || ""}
          onChange={(e) => set("maturity_date", e.target.value)}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:life.maturityBenefit')}</label>
        <input
          type="number"
          value={data.maturity_benefit ?? ""}
          onChange={(e) => set("maturity_benefit", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:life.maturityBenefitPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:life.riders')}</label>
        <input
          value={data.riders || ""}
          onChange={(e) => set("riders", e.target.value)}
          placeholder={t('insurance:life.ridersPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:life.surrenderValue')}</label>
        <input
          type="number"
          value={data.surrender_value ?? ""}
          onChange={(e) => set("surrender_value", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:life.surrenderValuePlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:life.loanValue')}</label>
        <input
          type="number"
          value={data.loan_value ?? ""}
          onChange={(e) => set("loan_value", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:life.loanValuePlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:life.premiumPaymentTerm')}</label>
        <input
          type="number"
          value={data.premium_payment_term ?? ""}
          onChange={(e) => set("premium_payment_term", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:life.premiumPaymentTermPlaceholder')}
        />
      </div>
    </div>
  );
};

export default LifeFields;
